import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Pasé de tener 20k seguidores y ganar $0, a facturar mi primer $1,200 USD en solo 3 semanas usando el Creator OS. El template de la Sales Page hizo que la gente no dudara en comprar. ¡Es oro puro!',
  name: 'Santi G.',
  location: 'Medellín',
  result: '$1,200 USD en 21 días'
}, {
  quote: 'Lo que más amé fue el Bonus de los 100 Prompts. Antes tardaba días en escribir mis guiones, ahora los tengo listos en 10 minutos y mis Reels están convirtiendo seguidores en clientes de WhatsApp cada hora.',
  name: 'Valeria M.',
  location: 'CDMX',
  result: '+45 ventas en su primera semana'
}, {
  quote: 'Era muy escéptica con estos cursos, pero el módulo de impuestos y legalidad en Latam me dio la confianza que necesitaba para empezar a cobrar en dólares desde Argentina sin miedo.',
  name: 'Lucas R.',
  location: 'Buenos Aires',
  result: 'Negocio formalizado y cobrando en USD'
}];
export function TestimonialsSection() {
  return <section className="bg-[#111111] py-24 px-4" data-id="element-128">
      <div className="max-w-5xl mx-auto" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-130">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-131">
            Lo que dicen nuestros alumnos
          </h2>
          <div className="w-16 h-1 bg-indigo-500 mx-auto rounded-full" data-id="element-132" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-133">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-[#0a0a0a] p-8 rounded-2xl border-l-4 border-l-indigo-500 border-y border-r border-white/5 shadow-lg flex flex-col h-full" data-id="element-134">
              <div className="flex gap-1 mb-6" data-id="element-135">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-indigo-400 text-indigo-400" data-id="element-136" />)}
              </div>

              <p className="text-gray-300 italic mb-8 flex-grow leading-relaxed" data-id="element-137">
                "{testimonial.quote}"
              </p>

              <div className="mt-auto" data-id="element-138">
                <p className="text-white font-bold text-lg" data-id="element-139">
                  {testimonial.name}
                </p>
                <p className="text-gray-500 text-sm mb-3" data-id="element-140">
                  {testimonial.location}
                </p>
                <div className="inline-block bg-green-500/10 border border-green-500/20 rounded-lg px-3 py-1.5" data-id="element-141">
                  <p className="text-green-400 text-sm font-semibold" data-id="element-142">
                    Resultado: {testimonial.result}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}